export type AssistantPosition = { x: number; y: number };

export function clampAssistantPosition(position: AssistantPosition, viewportWidth: number, viewportHeight: number, size: number, gap = 16): AssistantPosition {
  const maximumX = Math.max(gap, viewportWidth - size - gap);
  const maximumY = Math.max(gap, viewportHeight - size - gap);
  return { x: Math.min(Math.max(gap, position.x), maximumX), y: Math.min(Math.max(gap, position.y), maximumY) };
}

export function defaultAssistantPosition(viewportWidth: number, viewportHeight: number, size: number, gap = 16): AssistantPosition {
  return clampAssistantPosition({ x: viewportWidth - size - gap, y: viewportHeight - size - 20 }, viewportWidth, viewportHeight, size, gap);
}
